// extracted by mini-css-extract-plugin
module.exports = {"key":"style_key__3uY91","keyTitle":"style_keyTitle__3QcVd","value":"style_value__1tM4K","join":"style_join__2lr_H"};